import DIContainer from 'services/DIContainer';
import { OrderReportResponseDTO } from 'typings/dto/orderReport';
import Mapper from './Mapper';

export default class OrderReportMapper extends Mapper<OrderReport, OrderReportResponseDTO> {
  constructor(private subEntitiesMappers: DIContainer.SubEntitiesMappers) {
    super({
      completed: 'completed',
      fields: 'fields',
      name: 'name',
      technicalName: 'technicalName',
      description: 'description',
      integrationInfo: 'integrationInfo',
    });
  }

  public responseDTOToModel(dto: OrderReportResponseDTO): OrderReport {
    const outerMappers = this.getOuterMappers();
    const fieldsMapped = dto.fields.map((item) => this.subEntitiesMappers.dynamicField.responseDTOToModel(item, outerMappers));

    return {
      ...this.responseDTOToModelViaDiffMap(dto),
      fields: fieldsMapped,
      description: dto.description,
    };
  }
}
